import { API_URI, apiGet, apiPostAnon } from "./index";
import { apiPost, apiDelete } from "api";
import { AccessTokenSaveType } from "types";

const accessToken = {
    getAll: async (projectId: number) => {
        const data = await apiGet(`${API_URI}/api/accesstoken/getall?projectId=${projectId}`);
        return data;
    },
    getTwitterRequestToken: async (callbackUrl: string) => {
        const data = await apiGet(`${API_URI}/api/accesstoken/request/twitter/get?callbackUrl=${callbackUrl}`);
        return data;
    },
    save: async (profileId: string, name: string, projectId: number, streamId: number, token: string, handle: string, followerCount: number, tokenSecret: string, link: string, image: string, summary: string) => {
        const data = await apiPostAnon(
            `${API_URI}/api/profile/save?profileId=${profileId}&name=${name}&projectId=${projectId}&streamId=${streamId}&token=${token}&handle=${handle}&followerCount=${followerCount}&tokenSecret=${tokenSecret}&link=${link}&image=${image}&summary=${summary}`
        );
        return data;
    },
    saveV2: async (at: AccessTokenSaveType) => {
        const data = await apiPostAnon(`${API_URI}/api/profile/save/v2`, at);
        return data;
    },
    getLinkedInPages: async (code: string, projectId: number) => {
        const data = await apiPostAnon(`${API_URI}/api/profile/linkedin/pages/get?code=${code}&projectId=${projectId}`);
        return data;
    },
    updateAccessToken: async (profileId: string, accessToken: string, streamId: number) => {
        const data = await apiPostAnon(`${API_URI}/api/accesstoken/save?profileId=${profileId}&accessToken=${accessToken}&streamId=${streamId}`);
        return data;
    },
    delete: async (binruleId: Number, profileId: string, streamId: number, projectId: Number) => {
        const data = apiDelete(`${API_URI}/api/profile/delete?binruleId=${binruleId}&profileId=${profileId}&streamId=${streamId}&projectId=${projectId}`);
        return data;
    },
    revoke: async (profileId: string, streamId: number) => {
        const data = apiPost(`${API_URI}/api/accesstoken/revoke?profileId=${profileId}&streamId=${streamId}`);
        return data;
    },
    validateLinkedInToken: async (accesstoken: string) => {
        const data = await apiPost(`${API_URI}/api/accesstoken/linkedin/validate?accessToken=${accesstoken}`);
        return data;
    },
    validateTikTokToken: async (accesstoken: string) => {
        const data = await apiPost(`${API_URI}/api/accesstoken/tiktok/validate?accessToken=${accesstoken}`);
        return data;
    },
    saveTikTokToken: async (code: string, projectId: number) => {
        const data = await apiPostAnon(`${API_URI}/api/profile/tiktok/save?code=${code}&projectId=${projectId}`);
        return data;
    },
    localhostTestTikTokToken: async (code: string, projectId: number) => {
        const data = await apiPostAnon(`https://localhost:44314/api/profile/tiktok/save?code=${code}&projectId=${projectId}`);
        return data;
    },
};

export default accessToken;
